module.exports = __webpack_public_path__ + "img/gwyx-wkxfc.1581f8ff.png";